import { render, staticRenderFns } from "./AddJourneyDrawer.vue?vue&type=template&id=d52a18f4&"
import script from "./AddJourneyDrawer.vue?vue&type=script&lang=ts&"
export * from "./AddJourneyDrawer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports